import { Component, EventEmitter, Inject, Input, Output, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { SelectGroup } from '../select-panel/select-panel.types';
import { SelectPanelComponent } from '../select-panel/select-panel.component';

@Component({
  selector: 'wfm-select-dropdown',
  templateUrl: './select-dropdown.component.html',
  styleUrls: ['./select-dropdown.component.scss']
})
export class SelectDropdownComponent {
  @Input() items: Array<SelectGroup | any> = [];

  @Input() placeholder = '';

  @Input() value: any;
  @Output() valueChange = new EventEmitter<any>();

  @Input() labelField = '';

  @Input() iconField = '';

  @Input() maxSelection = 0;

  @Input() columns = 0;

  @Input() error = false;

  @Input() disabled = false;

  @Input() multiple = false;

  @Input() required = false;

  @Input() search = false;

  @Input() searchLabel;

  @Input() enableInternalSearch = true;

  @Input() highlightSelected = false;

  @Input() grouping = false;

  @Input() selectAllOption = false;

  @Input() translationEnabled = true;

  @Output() dropdownOpen = new EventEmitter();
  @Output() queryStr = new EventEmitter();

  query = '';

  isOpen = false;

  filteredItems: Array<SelectGroup | any>;

  private $minWidth = 0;

  get minWidth(): number {
    const _minWidth = this.$minWidth;
    this.$minWidth = this.trigger?.nativeElement.offsetWidth || 0;
    return _minWidth;
  }

  @ViewChild(SelectPanelComponent) panel: SelectPanelComponent;
  @ViewChild('trigger') trigger: ElementRef;

  get isListOfObjects(): boolean {
    if (this.grouping) {
      return typeof (this.items[0] as SelectGroup).items[0] === 'object';
    }
    return typeof this.items[0] === 'object';
  }

  get flatItems(): any[] {
    if (this.grouping) {
      return this.items.reduce((value, item) => (value as Array<any>).concat(item.items), []);
    }
    return this.items;
  }

  private window: Window;
  private mouseUpEvent: () => void;

  constructor(@Inject(DOCUMENT) private document, private renderer: Renderer2) {
    this.window = this.document.defaultView;
  }

  isOpenChange() {
    this.isOpen && this.window.setTimeout(() => this.panel?.scroll(), 0);
    this.isOpen && this.dropdownOpen.emit();
  }

  open() {
    if (!this.isOpen && !this.mouseUpEvent && !this.disabled) {
      this.isOpen = true;
      this.isOpenChange();
    }
  }

  mousedown() {
    if (this.isOpen) {
      this.mouseUpEvent = this.renderer.listen('document', 'mouseup', () => {
        this.mouseUpEvent();
        this.window.setTimeout(() => {
          this.mouseUpEvent = null;
        }, 0);
      });
    }
    this.dropdownOpen.emit();
  }

  onValueChange(value) {
    if (!this.multiple) {
      this.isOpen = false;
    }
    this.value = value;
    this.valueChange.emit(this.value);
  }

  onQueryStr(value) {
    this.queryStr.emit(value);
  }
}
